// extracted by mini-css-extract-plugin
module.exports = {"asset":"style_asset__2-oVv"};